import React, { Fragment }  from 'react';
import s from './NavBar.scss';
import axios from 'axios';
import AgilisLogo from '../../../assets/images/icons/Logo_azul_grande.svg';
import Isologo from '../../../assets/images/Isologo.svg';
import { PROPUESTA_URL, TOP_LEVEL_PREFIX, url, URL_BASE } from '../../../config';
import { tooltips } from '../../../tooltips';
import BurgerMenu from './BurgerMenu';
import ProfileMenu from '../UserWorkspace/ProfileMenu';
import { getMobileTitle, getMobileBackLink } from '../../../utils';
import Phone from './Phone';
import GoBackButton from './GoBackButton';
import Tooltip from 'rc-tooltip';
import Help from '../../../assets/images/icons/help-circle.svg';
import FooterMobile from './FooterMobile';
import LoginButton from '../Auth/Login/loginButton';

export default class NavBar extends React.Component {

    state = {
      open: false,
    }

    toggleOpen = () => {
      this.setState(prevState => {
        if (!prevState.open) {
          document.body.classList.add(s.lock);
          document.querySelector('html').classList.add(s.lock)
        }
        else {
          document.body.classList.remove(s.lock);
          document.querySelector('html').classList.remove(s.lock)
        }
        return {
          open: !prevState.open,
        }
      });
    }

    logoutUser = (e) => {
        axios.get('/api/v3/auth/logout/')
        .then(() => {
            window.location.href = "/";
        });
    }

    render(){
      const { status, PDFurl, userBorrower, is_staff, is_user, apptype, hot, urlLocation, match, abtestData, auth, style, goBack, authNav, destination }= this.props
      return(
          <Fragment>
              <div className={s.navContainer}>
                  <a href="/"><img src={AgilisLogo} className={s.agilisLogo} alt='Logo de Agilis'/></a>
                  <div className={s.phoneContainer}>
                      <p className={s.wannaTalk}>¿Querés hablar con tu asesor AGILIS?</p>
                      <p className={s.callText}>Llamalo al</p>
                      <Phone hot={hot} apptype={apptype}/>
                  </div>
                  {!auth ? (!is_staff && (is_user && is_user == 'ACTIVE'))
                      ? <ProfileMenu status={status} urlLocation={PDFurl} borrower={userBorrower} abtestData={abtestData}/>
                      :(apptype !== 'cp')
                        ? <div className={s.loginContainer}>
                            <p className={s.loginText}><i>¿Ya sos usuario?</i></p>
                            <a className={s.links} href={url('login') + '?next=' + url('mi-prestamo', apptype)}>Ingresá a tu cuenta</a>
                       </div>
                        : <a className={s.links} href={`${URL_BASE}/app/clear-app/?next_url=/prendas`}>Iniciar nueva solicitud</a>
                  : null}
              </div>
              {!authNav && <div className={s.mobile} style={style}>
                  {(this.state.open) ? null : (urlLocation != 'mi-prestamo') && <GoBackButton mobile={true} onClick={goBack} style={{marginTop: "22px", width: "16px", height: "13px"}} link={`${(!auth) ? (urlLocation != 'preaprobacion') ? match.url + getMobileBackLink(urlLocation, apptype) : url('propuesta', apptype) : ''}`}/>}
                  {(urlLocation == 'mi-prestamo') &&  <a href="/"><img src={Isologo} className={s.agilisIsologo} alt='Logo de Agilis'/></a>}
                  <h3 className={s.mobileTitle} style={(auth) ? {paddingLeft: '8px'} :  null}>
                      {(this.state.open) ? null : getMobileTitle(urlLocation, destination, abtestData)}
                      {(this.state.open) ? null : urlLocation == 'ingresos' && <Tooltip destroyTooltipOnHide placement="bottom" trigger={['click', 'hover']} overlayStyle={{ maxWidth: '300px'}} overlay={tooltips.incomes.map(({ description }) => [description])}>
                          <img className={s.helpImg} src={Help} alt={"icono de ayuda"}></img>
                      </Tooltip>
                      }
                      {(this.state.open) ? null : urlLocation == 'cotitulares' && <Tooltip destroyTooltipOnHide placement="bottom" trigger={['click', 'hover']} overlayStyle={{ maxWidth: '300px'}} overlay={tooltips.coborrower.map(({ description }) => [description])}>
                          <img className={s.helpImg} src={Help} alt={"icono de ayuda"}></img>
                      </Tooltip>
                      }
                  </h3>
                  {!auth ?
                     <BurgerMenu open={this.state.open} toggleOpen={this.toggleOpen}>
                          {({ toggleOpen }) => (
                              <div className={s.burgerLinks}>
                                {(!is_staff && (is_user && is_user == 'ACTIVE'))
                                  ? <ProfileMenu closeMenu={toggleOpen} status={status} urlLocation={PDFurl} borrower={userBorrower} mobileMenu={true}/>
                                  : (apptype !== 'cp') 
                                    ? <div className={s.loginContainer}>
                                        <p className={s.loginText}><i>¿Ya sos usuario?</i></p>
                                        <a className={s.links} href={url('login') + '?next=' + url('mi-prestamo', apptype)}><LoginButton children={'Ingresá a tu cuenta'} style={{width: '48%'}}/></a>
                                    </div>
                                    : <a className={s.links} href={`${URL_BASE}/app/clear-app/?next_url=/prendas`}><LoginButton children={'Iniciar nueva solicitud'} style={{width: '48%'}}/></a>
                                }
                                <FooterMobile mobile={true} abtestData={abtestData} status={status}/>
                                 {(!is_staff && (is_user && is_user == 'ACTIVE'))
                                  ? <div className={s.logoutContainer}>
                                      <a onClick={this.logoutUser}><LoginButton children={'Salir'} style={{width: '44%'}}/></a>
                                  </div>
                                  : null
                                  }
                              </div>
                          )}
                      </BurgerMenu>
                  : null}
              </div>}
          </Fragment>
      )
    }
}
